import React from 'react';

function Product({ product, setSelectedProduct }) {
  const { name, image, benefits = [], price } = product;

  return (
    <div className="product-card">
      <img
        className="product-image"
        src={image}
        alt={name}
      />

      <h3 className="product-name">{name}</h3>

      <ul className="product-benefits">
        {benefits.map((benefit, i) => (
          <li key={i}>{benefit}</li>
        ))}
      </ul>

      <p className="product-price">
        <span className="original-price">₹{product.originalPrice}</span>
        <span className="discounted-price">
          ₹{product.price}
          <span className="unit">{product.unit}</span>
        </span>
      </p>


      <button onClick={()=>setSelectedProduct(product)} className="buy-button">
        Buy Now
      </button>
    </div>
  );
}

export default Product;
